import { AiFillPlusCircle } from "react-icons/ai";

function FilledButton({ props }) {
  return (
    <div
      id={props.id}
      onClick={props.onClick}
      className="addnewhealth"
      style={props.style}
    >
      <div>
        <AiFillPlusCircle color="#4E91C2" size={25} />
      </div>
      <div>
        <button>{props.label}</button>
      </div>
    </div>
  );
}
export default FilledButton;
